import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { IntentsActions } from ".";
import {
  CLEAR_INTENTS_STATE,
  FETCH_INTENTS_LIST_PROGRESS,
  FETCH_INTENTS_LIST_SUCCESS,
  FETCH_INTENTS_LIST_FAILED,
} from "./IntentsActions";
import { initialIntents } from "./defaultState";
import { IIntents } from "./Intents.types";

export const intentsReducer = (
  state: IStoreState["intents"] = initialIntents,
  action: IntentsActions
) => {
  switch (action.type) {
    case FETCH_INTENTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState: IIntents) => {
        draftState.list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_INTENTS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState: IIntents) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.data = data;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_INTENTS_LIST_FAILED: {
      const newState = produce(state, (draftState: IIntents) => {
        draftState.list.loading = LoadState.Failed;
      });
      return newState;
    }
    case CLEAR_INTENTS_STATE: {
      return initialIntents;
    }
    default:
      return state;
  }
};
